module.exports = function () {
    function timeout(cb, delay){
        return setTimeout(cb, delay);
    }
    timeout.clear = function(t){
        return clearTimeout(t);
    };
    return timeout;
};



//////////////////
// WEBPACK FOOTER
// ./~/jpex-defaults/src/$timeout.js
// module id = 552
// module chunks = 40